import React from 'react';
import { connect } from 'react-redux';
import * as serviceWorkerRegistration from './../../serviceWorkerRegistration';
import { withStyles } from '@mui/styles';
import utilsService from './../../services/utils';
import packageJson from './../../package.alias.json';
import compareVersions from 'compare-versions';

import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { RenewIcon } from './../commons/Icons';

class AppUpdateController extends React.Component {

  constructor (props) {
    super(props);
    this.state = {
      waiting: false,
      open_update_banner: false,
    };
    this.swRegUpdateInterval = null;
    this.swRegUpdateFound = false;
    this.swReg = null;
  }

  componentDidMount () {
    this.register();
    this.survey();
  }

  componentWillUnmount () {
    this.stop();
  }

  register () {
    serviceWorkerRegistration.register({
      onSuccess: (registration) => {
        // SW installé (ou mis à jour), on surveille les nouvelles mise à jours
        this.survey();
      },
    });
  }

  survey () {
    if (!this.swRegUpdateInterval) {
      if (navigator.serviceWorker) {
        navigator.serviceWorker.getRegistration().then(registration => {
          if (registration) {
            this.swReg = registration;
            this.swRegUpdateInterval = setInterval(() => {
              if (!this.swRegUpdateFound) {
                registration.update()
              }
            }, 30000);
            // On écoute si une mise à jour du Service Worker est trouvée
            registration.addEventListener('updatefound', () => {
              // SW update found
              // On stoppe la recherche de mise à jour
              this.swRegUpdateFound = true
              clearInterval(this.swRegUpdateInterval);
              this.setState({
                open_update_banner: true
              });
            });
            // On écoute si une mise à jour du Service Worker est faite
            registration.addEventListener('updated', () => {
              // SW updated
            });
          }
        });
      }
    }
  }

  stop () {
    if (this.swRegUpdateInterval) {
      clearInterval(this.swRegUpdateInterval);
    }
    this.swRegUpdateFound = false;
  }

  update() {
    /*
     * On reload l'app en vidant les caches et en notifiant le service worker
     * si il a une mise à jour en attente.
     */
    utilsService.reloadApp();
  }

  wait () {
    this.setState({
      waiting: true,
    });
    setTimeout(() => {
      this.setState({
        waiting: false,
      });
    }, 15000);
  }

  render () {
    const { appStore } = this.props;

    /**
     * À chaque appel à l'API, le serveur nous renvoit une version minimale de compatibilité de l'application.
     * Si cette version de l'application n'est pas compatible, on demande à l'utilisateur de mettre à jour l'app.
     * NOTE : bien entendu, il est convenu que Bridger propose toujours une version compatible de l'app avec son API,
     */
    let app_version_deprecated = false;
    const api_minimal_version = appStore.api_minimal_version || null;
    if (api_minimal_version && api_minimal_version !== undefined && api_minimal_version !== null && api_minimal_version !== '') {
      if (compareVersions(packageJson.version, api_minimal_version) < 0) {
        app_version_deprecated = true;
      }
    }

    const openUpdateBanner = (this.state.open_update_banner || app_version_deprecated) && !this.state.waiting

    return (
      <React.Fragment>
        {this.props.children}
        <Dialog
          open={openUpdateBanner}
          onClose={ (e, reason) => {
            if (reason !== 'backdropClick') {
              this.wait();
            }
          } }
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">{"Une mise à jour est disponible..."}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Si certaines actions en cours ne sont pas sauvegardés, vous pouvez repousser la mise à jour. Sinon il est conseillé de mettre à jour l'application pour obtenir les dernières nouveautés et éviter tout bug.
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={ () => this.wait() } color="primary">
              Plus tard
            </Button>
            <Button variant="contained" color="primary" endIcon={<RenewIcon />} onClick={ () => this.update() }>
              Mettre à jour
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    );
  }
}

const styles = theme => ({});

const mapStateToProps = state => ({
	appStore: state.app,
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(AppUpdateController));
